module.exports = __webpack_public_path__ + "static/media/branding.b8e2693f.png";